export function propsAreTickProps(props) {
    var _a;
    return (props.x !== undefined &&
        props.y !== undefined &&
        ((_a = props.payload) === null || _a === void 0 ? void 0 : _a.value) !== undefined);
}
//# sourceMappingURL=recharts.js.map